export default __webpack_public_path__ + "static/media/r3.52d64ae3.jpg";